import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";

import type { DeleteProductPackageRequestDto } from "../../dtos/delete-product-package-request-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseDeleteProductPackageMutation = {
  options?: UseMutationOptions<
    { success: boolean },
    unknown,
    DeleteProductPackageRequestDto
  >;
};

export const useDeleteProductPackageMutation = ({
  options
}: UseDeleteProductPackageMutation = {}) => {
  const queryClient = useQueryClient();
  const { slug } = useParams({ from: "/products/list/$slug/edit" });

  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.deleteProductPackage({ payload });
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ProductQueryKeys.getProductDetail({
          slug
        }).queryKey
      });
      options?.onSuccess?.(...args);
    },
    ...options
  });
};
